/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProxyLink} from '../models/ProxyLink';

export interface GetAccountProxyLink$Request {
    accountId: number;
}

export interface GetAccountProxyLink$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountProxyLinkRequest = createAction<PayloadData<void, GetAccountProxyLink$Request>>('GET_ACCOUNT_PROXY_LINK__GET_ACCOUNT_PROXY_LINK__REQUEST');
export const getAccountProxyLinkSuccess = createAction<PayloadData<ProxyLink, GetAccountProxyLink$Request>>('GET_ACCOUNT_PROXY_LINK__GET_ACCOUNT_PROXY_LINK__SUCCESS');
export const getAccountProxyLinkFailure = createAction<PayloadData<Error, GetAccountProxyLink$Request, true>>('GET_ACCOUNT_PROXY_LINK__GET_ACCOUNT_PROXY_LINK__FAILURE');

export const getAccountProxyLinkActions = [
    getAccountProxyLinkRequest,
    getAccountProxyLinkSuccess,
    getAccountProxyLinkFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountProxyLink = (meta: GetAccountProxyLink$Request, config?: GetAccountProxyLink$Config) => {
    return {
        CALL_API: {
            types: getAccountProxyLinkActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/proxies`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

